<template>
  <v-layout row wrap data-qa="creditdetails-layout-jzbpqi">
    <Loader v-if="loaderEnabled" />
    <v-layout wrap class="ml-2" data-qa="creditdetails-layout-4usmeo">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="creditdetails-flex-p9ho6h">
        <v-container class="pa-6 pl-12" data-qa="creditdetails-container-tcu62t">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="creditdetails-flex-6ga9ki">
            <v-row no-gutters data-qa="creditdetails-row-72emoh">
              <v-layout row wrap class="pb-2" data-qa="creditdetails-layout-uxbymc">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                ></inline-svg>
                <font
                  class="display-1 font-weight-thin white--text pt-4 pl-2"
                  >{{ $t("cardDetails.creditLabel") }}</font
                >
              </v-layout>
            </v-row>
            <v-row data-qa="creditdetails-row-gii14m">
              <v-layout wrap class="pl-4" data-qa="creditdetails-layout-idk3lq">
                <v-layout column wrap data-qa="creditdetails-layout-n230ey">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-83e5mh">
                    <font class="subheading-1 font-weight-medium white--text">{{
                      $t("cardDetails.cardMaskedNumber")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="creditdetails-flex-b6358">
                    <font class="text-h5 font-weight-bold white--text">{{
                      cardMaskedNumber
                    }}</font>
                  </v-flex>
                </v-layout>
                <v-layout column wrap data-qa="creditdetails-layout-46z77w">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-pybmu9">
                    <font class="subheading-1 font-weight-medium white--text">{{
                      $t("cardDetails.cardName")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="creditdetails-flex-j09jmg">
                    <font class="text-h5 font-weight-bold white--text">{{
                      cardName
                    }}</font>
                  </v-flex>
                </v-layout>

                <v-layout column wrap data-qa="creditdetails-layout-ty8eu9">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-x5ylvh">
                    <font class="subheading font-weight-medium white--text">{{
                      $t("cardDetails.outstandingBalance")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="creditdetails-flex-7e34bc">
                    <font
                      class="text-h5 font-weight-bold white--text"
                      :color="
                        $formatter.currency.isNegativeBalance(cardBalance)
                          ? errorColor
                          : ''
                      "
                      >{{
                        $formatter.currency.format(cardBalance, cardCurrency)
                      }}</font
                    >
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-tabs
      v-model="currentTab"
      v-if="!isFetchingData"
      :color="primaryColor"
      class="pl-2"
     data-qa="creditdetails-tabs-wt879">
      <v-tab v-for="(item, i) of tabLabels" :key="i" class="px-6" :data-qa="`creditdetails-tab-9446qg-${i}`">
        <font class="subtitle-1 text-capitalize font-weight-bold px-6">{{
          item
        }}</font>
      </v-tab>
    </v-tabs>
    <v-container fluid v-if="!isFetchingData" data-qa="creditdetails-container-zu7omv">
      <v-flex lg10 data-qa="creditdetails-flex-g1iw3a">
        <v-tabs-items v-model="currentTab" data-qa="creditdetails-tabs-items-o1rfqg">
          <!-- Transactions Tab
    v-if="transactionList && !isAccountRestricted"-->
          <v-tab-item xl12 lg12 sm12 xs12 data-qa="creditdetails-tab-item-ybnoey">
            <v-row
              no-gutters
              class="ma-0 pa-3 px-6 cardDetailsInfo"
              :style="{ background: detailsInfoBackground }"
             data-qa="creditdetails-row-k01s3">
              <v-layout data-qa="creditdetails-layout-hkbb9">
                <v-container data-qa="creditdetails-container-i8kzf">
                  <v-row wrap class="pl-0" data-qa="creditdetails-row-y6q7k">
                    <v-flex xs12 sm12 md12 lg12 xl12 class="px-1 mb-4" data-qa="creditdetails-flex-kerybh">
                      <font class="subheading-1 font-weight-bold">Statement Details
                      </font>
                    </v-flex>
                  </v-row>
                  <v-row data-qa="creditdetails-row-qg8s9w">
                    <v-layout wrap class="pl-0" data-qa="creditdetails-layout-lr5xn">
                      <v-layout column wrap data-qa="creditdetails-layout-7bm5q">
                        <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-2a6ezp">
                          <font class="subheading-2 font-weight-bold">{{
                            $t("cardDetails.cardAmountDue")
                          }}:</font>
                          {{cardAmountDue}}
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout wrap class="pl-4" data-qa="creditdetails-layout-mwme7">
                      <v-layout column wrap data-qa="creditdetails-layout-ibvcl">
                        <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-j79iaf">
                          <font class="subheading-2 font-weight-bold">{{
                            $t("cardDetails.cardDueDate")
                          }}:</font>
                        {{cardDueDate}}
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout wrap class="pl-4" data-qa="creditdetails-layout-fdbc0d">
                      <v-layout column wrap data-qa="creditdetails-layout-dql5a8">
                        <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="creditdetails-flex-0s1uw9">
                          <font class="subheading-2 font-weight-bold">{{
                            $t("cardDetails.cardBillingDate")
                          }}:</font>
                        {{cardBillingDate}}
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-row>
                </v-container>
              </v-layout>
            </v-row>
            <v-row :style="{ background: defaultBackgroundColor }" data-qa="creditdetails-row-rmrqco">
              <Transactions
                :config="{
                  postingRestrictionType: '',
                  defaultAccountType: 'credit',
                }"
              />
            </v-row>
          </v-tab-item>
          <!-- Details Tab-->
          <v-tab-item data-qa="creditdetails-tab-item-gjtzbf">
            <v-row :style="{ background: defaultBackgroundColor }" class="pl-2" data-qa="creditdetails-row-mgfc2">
              <v-card tile class="py-2 pt-4" data-qa="creditdetails-card-slwk9r">
                <DisplayDetails
                  :config="{
                    title: $t('cardDetails.cardInfo'),
                    dataList: cardDetails,
                    translation: 'cardDetails',
                  }"
                  class="pl-5"
                />
                <!--TODO: add v-if if limits-->
                <v-divider data-qa="creditdetails-divider-hwxlmg"  class="pa-3" />
                <DisplayDetails
                  :config="{
                    title: $t('cardDetails.limits'),
                    dataList: cardLimits,
                    translation: 'cardDetails.cardLimits',
                  }"
                  class="pl-5 pb-2"
                />
              </v-card>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <!--ALERT-->
    </v-container>
  </v-layout>
</template>

<style scoped>
.cardDetailsInfo {
  border: solid #694ed6 1px;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 0px !important;
}
</style>

<script>
import commonService from '@/service/commonService.js'
import Transactions from '@/views/accounts/Transactions'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
// import PaymentStatus from '@/views/accounts/PaymentStatus'
// import OtpInput from '@/components/common/OtpInput.vue'
// import _ from 'lodash'
// import moment from 'moment'
// import event from '@/util/event'
// import store from '@/core/store'
import Loader from '../../../components/common/Loader.vue'
import '@/styles/pages/accounts/creditCards.scss'

export default {
  name: 'CreditDetails',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Loader,
    Transactions,
    DisplayDetails
    // PaymentStatus,
    // OtpInput
  },
  data () {
    return {
      loaderEnabled: false,
      currentTab: 0,
      tabLabels: ['Transactions', 'Details'],
      isFetchingData: false,
      cardDetails: [],
      cardLimits: [],
      cardAmountDue: '',
      cardDueDate: '',
      cardBillingDate: '',
      cardExpiryDate: ''
    }
  },
  async created () {
    this.cardType = this.config.params.cardType
    this.cardId = this.config.params.cardId
    this.cardName = this.config.params.cardName
    this.cardMaskedNumber = this.config.params.cardMaskedNumber
    this.cardBalance = this.config.params.cardBalance
    this.cardCurrency = this.config.params.cardCurrency
    this.cardStatus = this.config.params.cardStatus
    await this.getAccountDetails(this.cardId)
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('credit2')
    },
    async getAccountDetails (cardId) {
      const detailsResponse = await commonService.getCreditCardDetails(cardId)
      if (detailsResponse && !detailsResponse.causes) {
        this.cardAmountDue = this.$formatter.currency.format(detailsResponse.totalAmountDue.amount, detailsResponse.totalAmountDue.currency)
        this.cardDueDate = this.$formatter.formatDate(detailsResponse.dueDate)
        this.cardBillingDate = this.$formatter.formatDate(detailsResponse.nextBillingDate)
        this.cardExpiryDate = this.$formatter.formatDate(detailsResponse.expiryDate)
        this.cardDetails.push(
          {
            label: 'cardProduct',
            value: detailsResponse.creditCardProductName
          },
          {
            label: 'cardStatus',
            value: detailsResponse.cardStatus
          },
          {
            label: 'expiryDate',
            value: this.cardExpiryDate ? this.cardExpiryDate.substr(3, 2) + '/' + this.cardExpiryDate.substr(8, 2) : ''
          }
        )
      }
      const limitsResponse = await commonService.getCreditCardLimits(cardId)
      limitsResponse.items.forEach((item) => {
        this.cardLimits.push({
          label: item.type,
          value: this.$formatter.currency.format(
            item.amount,
            this.cardCurrency
          )
        })
      })
    }
  }
}
</script>
